import { FieldValidationError } from '../../../types/form/field-validation-error';
export const getStringLengthValidationRule = (minLength, maxLength) => {
    return data => {
        const length = data.trim().length;
        if (minLength !== undefined && length < minLength) {
            return FieldValidationError.Length;
        }
        if (maxLength !== undefined && length > maxLength) {
            return FieldValidationError.Length;
        }
        return undefined;
    };
};
//# sourceMappingURL=string-length-validation-rule.js.map